const styles = theme => ({
  headerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  headerContent: {
    padding: '24px',
    maxWidth: '692px',
    width: '100%',
    textAlign: 'center',
  },
})

export default styles
